/* eslint-disable */
import * as Types from '../../../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReportSubscriptionFragmentFragment = { __typename?: 'ReportSubscription', id: string, brandCode: string, rmUserId: number, isActive: boolean, timezone: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'ReportSubscriptionPreferences', includeMonday: boolean, includeTuesday: boolean, includeWednesday: boolean, includeThursday: boolean, includeFriday: boolean, includeSaturday: boolean, includeSunday: boolean, deliveryTime: string, useAiNotes: boolean, description?: string | null, recipientTeamMemberIds?: Array<string> | null, startDate?: string | null, endDate?: string | null, message?: string | null, priority: number }, hotel?: { __typename?: 'Hotel', brand_code: any, name?: string | null } | null };

export type ReportSubscriptionResponseFragmentFragment = { __typename?: 'ReportSubscriptionResponse', success: boolean, message?: string | null, subscription?: { __typename?: 'ReportSubscription', id: string, brandCode: string, rmUserId: number, isActive: boolean, timezone: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'ReportSubscriptionPreferences', includeMonday: boolean, includeTuesday: boolean, includeWednesday: boolean, includeThursday: boolean, includeFriday: boolean, includeSaturday: boolean, includeSunday: boolean, deliveryTime: string, useAiNotes: boolean, description?: string | null, recipientTeamMemberIds?: Array<string> | null, startDate?: string | null, endDate?: string | null, message?: string | null, priority: number }, hotel?: { __typename?: 'Hotel', brand_code: any, name?: string | null } | null } | null };

export type GetReportSubscriptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetReportSubscriptionsQuery = { __typename?: 'Query', reportSubscriptions?: Array<{ __typename?: 'ReportSubscription', id: string, brandCode: string, rmUserId: number, isActive: boolean, timezone: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'ReportSubscriptionPreferences', includeMonday: boolean, includeTuesday: boolean, includeWednesday: boolean, includeThursday: boolean, includeFriday: boolean, includeSaturday: boolean, includeSunday: boolean, deliveryTime: string, useAiNotes: boolean, description?: string | null, recipientTeamMemberIds?: Array<string> | null, startDate?: string | null, endDate?: string | null, message?: string | null, priority: number }, hotel?: { __typename?: 'Hotel', brand_code: any, name?: string | null } | null } | null> | null };

export type GetReportSubscriptionsByBrandQueryVariables = Types.Exact<{
  brandCode: Types.Scalars['String'];
}>;


export type GetReportSubscriptionsByBrandQuery = { __typename?: 'Query', reportSubscriptionsByBrand?: Array<{ __typename?: 'ReportSubscription', id: string, brandCode: string, rmUserId: number, isActive: boolean, timezone: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'ReportSubscriptionPreferences', includeMonday: boolean, includeTuesday: boolean, includeWednesday: boolean, includeThursday: boolean, includeFriday: boolean, includeSaturday: boolean, includeSunday: boolean, deliveryTime: string, useAiNotes: boolean, description?: string | null, recipientTeamMemberIds?: Array<string> | null, startDate?: string | null, endDate?: string | null, message?: string | null, priority: number }, hotel?: { __typename?: 'Hotel', brand_code: any, name?: string | null } | null } | null> | null };

export type GetReportSubscriptionQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetReportSubscriptionQuery = { __typename?: 'Query', reportSubscription?: { __typename?: 'ReportSubscription', id: string, brandCode: string, rmUserId: number, isActive: boolean, timezone: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'ReportSubscriptionPreferences', includeMonday: boolean, includeTuesday: boolean, includeWednesday: boolean, includeThursday: boolean, includeFriday: boolean, includeSaturday: boolean, includeSunday: boolean, deliveryTime: string, useAiNotes: boolean, description?: string | null, recipientTeamMemberIds?: Array<string> | null, startDate?: string | null, endDate?: string | null, message?: string | null, priority: number }, hotel?: { __typename?: 'Hotel', brand_code: any, name?: string | null } | null } | null };

export type IsSubscribedToAutomatedReportsQueryVariables = Types.Exact<{
  brandCode: Types.Scalars['String'];
}>;


export type IsSubscribedToAutomatedReportsQuery = { __typename?: 'Query', isSubscribedToAutomatedReports: boolean };

export type GetUserDropdownOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserDropdownOptionsQuery = { __typename?: 'Query', userDropdownOptions: Array<{ __typename?: 'UserDropdownOption', id: number, name?: string | null, email?: string | null }> };

export type GetHotelTeamForRecipientsQueryVariables = Types.Exact<{
  brandCode: Types.Scalars['String'];
}>;


export type GetHotelTeamForRecipientsQuery = { __typename?: 'Query', getHotelTeam?: Array<{ __typename?: 'TeamMember', id?: string | null, name?: string | null, email?: string | null, active?: Types.TeamMemberActive | null, emailPref?: Types.MeetingEmail | null } | null> | null };

export type CreateReportSubscriptionMutationVariables = Types.Exact<{
  input: Types.CreateReportSubscriptionInput;
}>;


export type CreateReportSubscriptionMutation = { __typename?: 'Mutation', createReportSubscription: { __typename?: 'ReportSubscriptionResponse', success: boolean, message?: string | null, subscription?: { __typename?: 'ReportSubscription', id: string, brandCode: string, rmUserId: number, isActive: boolean, timezone: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'ReportSubscriptionPreferences', includeMonday: boolean, includeTuesday: boolean, includeWednesday: boolean, includeThursday: boolean, includeFriday: boolean, includeSaturday: boolean, includeSunday: boolean, deliveryTime: string, useAiNotes: boolean, description?: string | null, recipientTeamMemberIds?: Array<string> | null, startDate?: string | null, endDate?: string | null, message?: string | null, priority: number }, hotel?: { __typename?: 'Hotel', brand_code: any, name?: string | null } | null } | null } };

export type UpdateReportSubscriptionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  input: Types.UpdateReportSubscriptionInput;
}>;


export type UpdateReportSubscriptionMutation = { __typename?: 'Mutation', updateReportSubscription: { __typename?: 'ReportSubscriptionResponse', success: boolean, message?: string | null, subscription?: { __typename?: 'ReportSubscription', id: string, brandCode: string, rmUserId: number, isActive: boolean, timezone: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'ReportSubscriptionPreferences', includeMonday: boolean, includeTuesday: boolean, includeWednesday: boolean, includeThursday: boolean, includeFriday: boolean, includeSaturday: boolean, includeSunday: boolean, deliveryTime: string, useAiNotes: boolean, description?: string | null, recipientTeamMemberIds?: Array<string> | null, startDate?: string | null, endDate?: string | null, message?: string | null, priority: number }, hotel?: { __typename?: 'Hotel', brand_code: any, name?: string | null } | null } | null } };

export type DeleteReportSubscriptionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type DeleteReportSubscriptionMutation = { __typename?: 'Mutation', deleteReportSubscription: { __typename?: 'ReportSubscriptionResponse', success: boolean, message?: string | null, subscription?: { __typename?: 'ReportSubscription', id: string, brandCode: string, rmUserId: number, isActive: boolean, timezone: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'ReportSubscriptionPreferences', includeMonday: boolean, includeTuesday: boolean, includeWednesday: boolean, includeThursday: boolean, includeFriday: boolean, includeSaturday: boolean, includeSunday: boolean, deliveryTime: string, useAiNotes: boolean, description?: string | null, recipientTeamMemberIds?: Array<string> | null, startDate?: string | null, endDate?: string | null, message?: string | null, priority: number }, hotel?: { __typename?: 'Hotel', brand_code: any, name?: string | null } | null } | null } };

export type SubscribeToAutomatedReportsMutationVariables = Types.Exact<{
  brandCode: Types.Scalars['String'];
  timezone?: Types.InputMaybe<Types.Scalars['String']>;
  preferences?: Types.InputMaybe<Types.ReportSubscriptionPreferencesInput>;
}>;


export type SubscribeToAutomatedReportsMutation = { __typename?: 'Mutation', subscribeToAutomatedReports: { __typename?: 'ReportSubscriptionResponse', success: boolean, message?: string | null, subscription?: { __typename?: 'ReportSubscription', id: string, brandCode: string, rmUserId: number, isActive: boolean, timezone: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'ReportSubscriptionPreferences', includeMonday: boolean, includeTuesday: boolean, includeWednesday: boolean, includeThursday: boolean, includeFriday: boolean, includeSaturday: boolean, includeSunday: boolean, deliveryTime: string, useAiNotes: boolean, description?: string | null, recipientTeamMemberIds?: Array<string> | null, startDate?: string | null, endDate?: string | null, message?: string | null, priority: number }, hotel?: { __typename?: 'Hotel', brand_code: any, name?: string | null } | null } | null } };

export type UnsubscribeFromAutomatedReportsMutationVariables = Types.Exact<{
  brandCode: Types.Scalars['String'];
}>;


export type UnsubscribeFromAutomatedReportsMutation = { __typename?: 'Mutation', unsubscribeFromAutomatedReports: { __typename?: 'ReportSubscriptionResponse', success: boolean, message?: string | null, subscription?: { __typename?: 'ReportSubscription', id: string, brandCode: string, rmUserId: number, isActive: boolean, timezone: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'ReportSubscriptionPreferences', includeMonday: boolean, includeTuesday: boolean, includeWednesday: boolean, includeThursday: boolean, includeFriday: boolean, includeSaturday: boolean, includeSunday: boolean, deliveryTime: string, useAiNotes: boolean, description?: string | null, recipientTeamMemberIds?: Array<string> | null, startDate?: string | null, endDate?: string | null, message?: string | null, priority: number }, hotel?: { __typename?: 'Hotel', brand_code: any, name?: string | null } | null } | null } };

export type UpdateAutomatedReportPreferencesMutationVariables = Types.Exact<{
  brandCode: Types.Scalars['String'];
  preferences: Types.ReportSubscriptionPreferencesInput;
  timezone?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type UpdateAutomatedReportPreferencesMutation = { __typename?: 'Mutation', updateAutomatedReportPreferences: { __typename?: 'ReportSubscriptionResponse', success: boolean, message?: string | null, subscription?: { __typename?: 'ReportSubscription', id: string, brandCode: string, rmUserId: number, isActive: boolean, timezone: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'ReportSubscriptionPreferences', includeMonday: boolean, includeTuesday: boolean, includeWednesday: boolean, includeThursday: boolean, includeFriday: boolean, includeSaturday: boolean, includeSunday: boolean, deliveryTime: string, useAiNotes: boolean, description?: string | null, recipientTeamMemberIds?: Array<string> | null, startDate?: string | null, endDate?: string | null, message?: string | null, priority: number }, hotel?: { __typename?: 'Hotel', brand_code: any, name?: string | null } | null } | null } };

export type TriggerReportSubscriptionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type TriggerReportSubscriptionMutation = { __typename?: 'Mutation', triggerReportSubscription: { __typename?: 'ReportSubscriptionResponse', success: boolean, message?: string | null, subscription?: { __typename?: 'ReportSubscription', id: string, brandCode: string, rmUserId: number, isActive: boolean, timezone: string, createdAt: any, updatedAt: any, preferences: { __typename?: 'ReportSubscriptionPreferences', includeMonday: boolean, includeTuesday: boolean, includeWednesday: boolean, includeThursday: boolean, includeFriday: boolean, includeSaturday: boolean, includeSunday: boolean, deliveryTime: string, useAiNotes: boolean, description?: string | null, recipientTeamMemberIds?: Array<string> | null, startDate?: string | null, endDate?: string | null, message?: string | null, priority: number }, hotel?: { __typename?: 'Hotel', brand_code: any, name?: string | null } | null } | null } };

export const ReportSubscriptionFragmentFragmentDoc = gql`
    fragment ReportSubscriptionFragment on ReportSubscription {
  id
  brandCode
  rmUserId
  isActive
  timezone
  preferences {
    includeMonday
    includeTuesday
    includeWednesday
    includeThursday
    includeFriday
    includeSaturday
    includeSunday
    deliveryTime
    useAiNotes
    description
    recipientTeamMemberIds
    startDate
    endDate
    message
    priority
  }
  createdAt
  updatedAt
  hotel {
    brand_code
    name
  }
}
    `;
export const ReportSubscriptionResponseFragmentFragmentDoc = gql`
    fragment ReportSubscriptionResponseFragment on ReportSubscriptionResponse {
  success
  message
  subscription {
    ...ReportSubscriptionFragment
  }
}
    ${ReportSubscriptionFragmentFragmentDoc}`;
export const GetReportSubscriptionsDocument = gql`
    query GetReportSubscriptions {
  reportSubscriptions {
    ...ReportSubscriptionFragment
  }
}
    ${ReportSubscriptionFragmentFragmentDoc}`;

/**
 * __useGetReportSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetReportSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetReportSubscriptionsQuery, GetReportSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportSubscriptionsQuery, GetReportSubscriptionsQueryVariables>(GetReportSubscriptionsDocument, options);
      }
export function useGetReportSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportSubscriptionsQuery, GetReportSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportSubscriptionsQuery, GetReportSubscriptionsQueryVariables>(GetReportSubscriptionsDocument, options);
        }
export type GetReportSubscriptionsQueryHookResult = ReturnType<typeof useGetReportSubscriptionsQuery>;
export type GetReportSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetReportSubscriptionsLazyQuery>;
export type GetReportSubscriptionsQueryResult = Apollo.QueryResult<GetReportSubscriptionsQuery, GetReportSubscriptionsQueryVariables>;
export const GetReportSubscriptionsByBrandDocument = gql`
    query GetReportSubscriptionsByBrand($brandCode: String!) {
  reportSubscriptionsByBrand(brandCode: $brandCode) {
    ...ReportSubscriptionFragment
  }
}
    ${ReportSubscriptionFragmentFragmentDoc}`;

/**
 * __useGetReportSubscriptionsByBrandQuery__
 *
 * To run a query within a React component, call `useGetReportSubscriptionsByBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportSubscriptionsByBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportSubscriptionsByBrandQuery({
 *   variables: {
 *      brandCode: // value for 'brandCode'
 *   },
 * });
 */
export function useGetReportSubscriptionsByBrandQuery(baseOptions: Apollo.QueryHookOptions<GetReportSubscriptionsByBrandQuery, GetReportSubscriptionsByBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportSubscriptionsByBrandQuery, GetReportSubscriptionsByBrandQueryVariables>(GetReportSubscriptionsByBrandDocument, options);
      }
export function useGetReportSubscriptionsByBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportSubscriptionsByBrandQuery, GetReportSubscriptionsByBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportSubscriptionsByBrandQuery, GetReportSubscriptionsByBrandQueryVariables>(GetReportSubscriptionsByBrandDocument, options);
        }
export type GetReportSubscriptionsByBrandQueryHookResult = ReturnType<typeof useGetReportSubscriptionsByBrandQuery>;
export type GetReportSubscriptionsByBrandLazyQueryHookResult = ReturnType<typeof useGetReportSubscriptionsByBrandLazyQuery>;
export type GetReportSubscriptionsByBrandQueryResult = Apollo.QueryResult<GetReportSubscriptionsByBrandQuery, GetReportSubscriptionsByBrandQueryVariables>;
export const GetReportSubscriptionDocument = gql`
    query GetReportSubscription($id: ID!) {
  reportSubscription(id: $id) {
    ...ReportSubscriptionFragment
  }
}
    ${ReportSubscriptionFragmentFragmentDoc}`;

/**
 * __useGetReportSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetReportSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetReportSubscriptionQuery, GetReportSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportSubscriptionQuery, GetReportSubscriptionQueryVariables>(GetReportSubscriptionDocument, options);
      }
export function useGetReportSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportSubscriptionQuery, GetReportSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportSubscriptionQuery, GetReportSubscriptionQueryVariables>(GetReportSubscriptionDocument, options);
        }
export type GetReportSubscriptionQueryHookResult = ReturnType<typeof useGetReportSubscriptionQuery>;
export type GetReportSubscriptionLazyQueryHookResult = ReturnType<typeof useGetReportSubscriptionLazyQuery>;
export type GetReportSubscriptionQueryResult = Apollo.QueryResult<GetReportSubscriptionQuery, GetReportSubscriptionQueryVariables>;
export const IsSubscribedToAutomatedReportsDocument = gql`
    query IsSubscribedToAutomatedReports($brandCode: String!) {
  isSubscribedToAutomatedReports(brandCode: $brandCode)
}
    `;

/**
 * __useIsSubscribedToAutomatedReportsQuery__
 *
 * To run a query within a React component, call `useIsSubscribedToAutomatedReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsSubscribedToAutomatedReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsSubscribedToAutomatedReportsQuery({
 *   variables: {
 *      brandCode: // value for 'brandCode'
 *   },
 * });
 */
export function useIsSubscribedToAutomatedReportsQuery(baseOptions: Apollo.QueryHookOptions<IsSubscribedToAutomatedReportsQuery, IsSubscribedToAutomatedReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsSubscribedToAutomatedReportsQuery, IsSubscribedToAutomatedReportsQueryVariables>(IsSubscribedToAutomatedReportsDocument, options);
      }
export function useIsSubscribedToAutomatedReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsSubscribedToAutomatedReportsQuery, IsSubscribedToAutomatedReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsSubscribedToAutomatedReportsQuery, IsSubscribedToAutomatedReportsQueryVariables>(IsSubscribedToAutomatedReportsDocument, options);
        }
export type IsSubscribedToAutomatedReportsQueryHookResult = ReturnType<typeof useIsSubscribedToAutomatedReportsQuery>;
export type IsSubscribedToAutomatedReportsLazyQueryHookResult = ReturnType<typeof useIsSubscribedToAutomatedReportsLazyQuery>;
export type IsSubscribedToAutomatedReportsQueryResult = Apollo.QueryResult<IsSubscribedToAutomatedReportsQuery, IsSubscribedToAutomatedReportsQueryVariables>;
export const GetUserDropdownOptionsDocument = gql`
    query GetUserDropdownOptions {
  userDropdownOptions {
    id
    name
    email
  }
}
    `;

/**
 * __useGetUserDropdownOptionsQuery__
 *
 * To run a query within a React component, call `useGetUserDropdownOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDropdownOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDropdownOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserDropdownOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserDropdownOptionsQuery, GetUserDropdownOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDropdownOptionsQuery, GetUserDropdownOptionsQueryVariables>(GetUserDropdownOptionsDocument, options);
      }
export function useGetUserDropdownOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDropdownOptionsQuery, GetUserDropdownOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDropdownOptionsQuery, GetUserDropdownOptionsQueryVariables>(GetUserDropdownOptionsDocument, options);
        }
export type GetUserDropdownOptionsQueryHookResult = ReturnType<typeof useGetUserDropdownOptionsQuery>;
export type GetUserDropdownOptionsLazyQueryHookResult = ReturnType<typeof useGetUserDropdownOptionsLazyQuery>;
export type GetUserDropdownOptionsQueryResult = Apollo.QueryResult<GetUserDropdownOptionsQuery, GetUserDropdownOptionsQueryVariables>;
export const GetHotelTeamForRecipientsDocument = gql`
    query GetHotelTeamForRecipients($brandCode: String!) {
  getHotelTeam(brandCode: $brandCode, active: ACTIVE) {
    id
    name
    email
    active
    emailPref
  }
}
    `;

/**
 * __useGetHotelTeamForRecipientsQuery__
 *
 * To run a query within a React component, call `useGetHotelTeamForRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotelTeamForRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotelTeamForRecipientsQuery({
 *   variables: {
 *      brandCode: // value for 'brandCode'
 *   },
 * });
 */
export function useGetHotelTeamForRecipientsQuery(baseOptions: Apollo.QueryHookOptions<GetHotelTeamForRecipientsQuery, GetHotelTeamForRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHotelTeamForRecipientsQuery, GetHotelTeamForRecipientsQueryVariables>(GetHotelTeamForRecipientsDocument, options);
      }
export function useGetHotelTeamForRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHotelTeamForRecipientsQuery, GetHotelTeamForRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHotelTeamForRecipientsQuery, GetHotelTeamForRecipientsQueryVariables>(GetHotelTeamForRecipientsDocument, options);
        }
export type GetHotelTeamForRecipientsQueryHookResult = ReturnType<typeof useGetHotelTeamForRecipientsQuery>;
export type GetHotelTeamForRecipientsLazyQueryHookResult = ReturnType<typeof useGetHotelTeamForRecipientsLazyQuery>;
export type GetHotelTeamForRecipientsQueryResult = Apollo.QueryResult<GetHotelTeamForRecipientsQuery, GetHotelTeamForRecipientsQueryVariables>;
export const CreateReportSubscriptionDocument = gql`
    mutation CreateReportSubscription($input: CreateReportSubscriptionInput!) {
  createReportSubscription(input: $input) {
    ...ReportSubscriptionResponseFragment
  }
}
    ${ReportSubscriptionResponseFragmentFragmentDoc}`;
export type CreateReportSubscriptionMutationFn = Apollo.MutationFunction<CreateReportSubscriptionMutation, CreateReportSubscriptionMutationVariables>;

/**
 * __useCreateReportSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateReportSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportSubscriptionMutation, { data, loading, error }] = useCreateReportSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportSubscriptionMutation, CreateReportSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportSubscriptionMutation, CreateReportSubscriptionMutationVariables>(CreateReportSubscriptionDocument, options);
      }
export type CreateReportSubscriptionMutationHookResult = ReturnType<typeof useCreateReportSubscriptionMutation>;
export type CreateReportSubscriptionMutationResult = Apollo.MutationResult<CreateReportSubscriptionMutation>;
export type CreateReportSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateReportSubscriptionMutation, CreateReportSubscriptionMutationVariables>;
export const UpdateReportSubscriptionDocument = gql`
    mutation UpdateReportSubscription($id: ID!, $input: UpdateReportSubscriptionInput!) {
  updateReportSubscription(id: $id, input: $input) {
    ...ReportSubscriptionResponseFragment
  }
}
    ${ReportSubscriptionResponseFragmentFragmentDoc}`;
export type UpdateReportSubscriptionMutationFn = Apollo.MutationFunction<UpdateReportSubscriptionMutation, UpdateReportSubscriptionMutationVariables>;

/**
 * __useUpdateReportSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateReportSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportSubscriptionMutation, { data, loading, error }] = useUpdateReportSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportSubscriptionMutation, UpdateReportSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportSubscriptionMutation, UpdateReportSubscriptionMutationVariables>(UpdateReportSubscriptionDocument, options);
      }
export type UpdateReportSubscriptionMutationHookResult = ReturnType<typeof useUpdateReportSubscriptionMutation>;
export type UpdateReportSubscriptionMutationResult = Apollo.MutationResult<UpdateReportSubscriptionMutation>;
export type UpdateReportSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateReportSubscriptionMutation, UpdateReportSubscriptionMutationVariables>;
export const DeleteReportSubscriptionDocument = gql`
    mutation DeleteReportSubscription($id: ID!) {
  deleteReportSubscription(id: $id) {
    ...ReportSubscriptionResponseFragment
  }
}
    ${ReportSubscriptionResponseFragmentFragmentDoc}`;
export type DeleteReportSubscriptionMutationFn = Apollo.MutationFunction<DeleteReportSubscriptionMutation, DeleteReportSubscriptionMutationVariables>;

/**
 * __useDeleteReportSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteReportSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportSubscriptionMutation, { data, loading, error }] = useDeleteReportSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReportSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportSubscriptionMutation, DeleteReportSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportSubscriptionMutation, DeleteReportSubscriptionMutationVariables>(DeleteReportSubscriptionDocument, options);
      }
export type DeleteReportSubscriptionMutationHookResult = ReturnType<typeof useDeleteReportSubscriptionMutation>;
export type DeleteReportSubscriptionMutationResult = Apollo.MutationResult<DeleteReportSubscriptionMutation>;
export type DeleteReportSubscriptionMutationOptions = Apollo.BaseMutationOptions<DeleteReportSubscriptionMutation, DeleteReportSubscriptionMutationVariables>;
export const SubscribeToAutomatedReportsDocument = gql`
    mutation SubscribeToAutomatedReports($brandCode: String!, $timezone: String, $preferences: ReportSubscriptionPreferencesInput) {
  subscribeToAutomatedReports(
    brandCode: $brandCode
    timezone: $timezone
    preferences: $preferences
  ) {
    ...ReportSubscriptionResponseFragment
  }
}
    ${ReportSubscriptionResponseFragmentFragmentDoc}`;
export type SubscribeToAutomatedReportsMutationFn = Apollo.MutationFunction<SubscribeToAutomatedReportsMutation, SubscribeToAutomatedReportsMutationVariables>;

/**
 * __useSubscribeToAutomatedReportsMutation__
 *
 * To run a mutation, you first call `useSubscribeToAutomatedReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToAutomatedReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToAutomatedReportsMutation, { data, loading, error }] = useSubscribeToAutomatedReportsMutation({
 *   variables: {
 *      brandCode: // value for 'brandCode'
 *      timezone: // value for 'timezone'
 *      preferences: // value for 'preferences'
 *   },
 * });
 */
export function useSubscribeToAutomatedReportsMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToAutomatedReportsMutation, SubscribeToAutomatedReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToAutomatedReportsMutation, SubscribeToAutomatedReportsMutationVariables>(SubscribeToAutomatedReportsDocument, options);
      }
export type SubscribeToAutomatedReportsMutationHookResult = ReturnType<typeof useSubscribeToAutomatedReportsMutation>;
export type SubscribeToAutomatedReportsMutationResult = Apollo.MutationResult<SubscribeToAutomatedReportsMutation>;
export type SubscribeToAutomatedReportsMutationOptions = Apollo.BaseMutationOptions<SubscribeToAutomatedReportsMutation, SubscribeToAutomatedReportsMutationVariables>;
export const UnsubscribeFromAutomatedReportsDocument = gql`
    mutation UnsubscribeFromAutomatedReports($brandCode: String!) {
  unsubscribeFromAutomatedReports(brandCode: $brandCode) {
    ...ReportSubscriptionResponseFragment
  }
}
    ${ReportSubscriptionResponseFragmentFragmentDoc}`;
export type UnsubscribeFromAutomatedReportsMutationFn = Apollo.MutationFunction<UnsubscribeFromAutomatedReportsMutation, UnsubscribeFromAutomatedReportsMutationVariables>;

/**
 * __useUnsubscribeFromAutomatedReportsMutation__
 *
 * To run a mutation, you first call `useUnsubscribeFromAutomatedReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeFromAutomatedReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeFromAutomatedReportsMutation, { data, loading, error }] = useUnsubscribeFromAutomatedReportsMutation({
 *   variables: {
 *      brandCode: // value for 'brandCode'
 *   },
 * });
 */
export function useUnsubscribeFromAutomatedReportsMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeFromAutomatedReportsMutation, UnsubscribeFromAutomatedReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeFromAutomatedReportsMutation, UnsubscribeFromAutomatedReportsMutationVariables>(UnsubscribeFromAutomatedReportsDocument, options);
      }
export type UnsubscribeFromAutomatedReportsMutationHookResult = ReturnType<typeof useUnsubscribeFromAutomatedReportsMutation>;
export type UnsubscribeFromAutomatedReportsMutationResult = Apollo.MutationResult<UnsubscribeFromAutomatedReportsMutation>;
export type UnsubscribeFromAutomatedReportsMutationOptions = Apollo.BaseMutationOptions<UnsubscribeFromAutomatedReportsMutation, UnsubscribeFromAutomatedReportsMutationVariables>;
export const UpdateAutomatedReportPreferencesDocument = gql`
    mutation UpdateAutomatedReportPreferences($brandCode: String!, $preferences: ReportSubscriptionPreferencesInput!, $timezone: String) {
  updateAutomatedReportPreferences(
    brandCode: $brandCode
    preferences: $preferences
    timezone: $timezone
  ) {
    ...ReportSubscriptionResponseFragment
  }
}
    ${ReportSubscriptionResponseFragmentFragmentDoc}`;
export type UpdateAutomatedReportPreferencesMutationFn = Apollo.MutationFunction<UpdateAutomatedReportPreferencesMutation, UpdateAutomatedReportPreferencesMutationVariables>;

/**
 * __useUpdateAutomatedReportPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateAutomatedReportPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomatedReportPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomatedReportPreferencesMutation, { data, loading, error }] = useUpdateAutomatedReportPreferencesMutation({
 *   variables: {
 *      brandCode: // value for 'brandCode'
 *      preferences: // value for 'preferences'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useUpdateAutomatedReportPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomatedReportPreferencesMutation, UpdateAutomatedReportPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomatedReportPreferencesMutation, UpdateAutomatedReportPreferencesMutationVariables>(UpdateAutomatedReportPreferencesDocument, options);
      }
export type UpdateAutomatedReportPreferencesMutationHookResult = ReturnType<typeof useUpdateAutomatedReportPreferencesMutation>;
export type UpdateAutomatedReportPreferencesMutationResult = Apollo.MutationResult<UpdateAutomatedReportPreferencesMutation>;
export type UpdateAutomatedReportPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateAutomatedReportPreferencesMutation, UpdateAutomatedReportPreferencesMutationVariables>;
export const TriggerReportSubscriptionDocument = gql`
    mutation TriggerReportSubscription($id: ID!) {
  triggerReportSubscription(id: $id) {
    ...ReportSubscriptionResponseFragment
  }
}
    ${ReportSubscriptionResponseFragmentFragmentDoc}`;
export type TriggerReportSubscriptionMutationFn = Apollo.MutationFunction<TriggerReportSubscriptionMutation, TriggerReportSubscriptionMutationVariables>;

/**
 * __useTriggerReportSubscriptionMutation__
 *
 * To run a mutation, you first call `useTriggerReportSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerReportSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerReportSubscriptionMutation, { data, loading, error }] = useTriggerReportSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggerReportSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<TriggerReportSubscriptionMutation, TriggerReportSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerReportSubscriptionMutation, TriggerReportSubscriptionMutationVariables>(TriggerReportSubscriptionDocument, options);
      }
export type TriggerReportSubscriptionMutationHookResult = ReturnType<typeof useTriggerReportSubscriptionMutation>;
export type TriggerReportSubscriptionMutationResult = Apollo.MutationResult<TriggerReportSubscriptionMutation>;
export type TriggerReportSubscriptionMutationOptions = Apollo.BaseMutationOptions<TriggerReportSubscriptionMutation, TriggerReportSubscriptionMutationVariables>;
export const namedOperations = {
  Query: {
    GetReportSubscriptions: 'GetReportSubscriptions',
    GetReportSubscriptionsByBrand: 'GetReportSubscriptionsByBrand',
    GetReportSubscription: 'GetReportSubscription',
    IsSubscribedToAutomatedReports: 'IsSubscribedToAutomatedReports',
    GetUserDropdownOptions: 'GetUserDropdownOptions',
    GetHotelTeamForRecipients: 'GetHotelTeamForRecipients'
  },
  Mutation: {
    CreateReportSubscription: 'CreateReportSubscription',
    UpdateReportSubscription: 'UpdateReportSubscription',
    DeleteReportSubscription: 'DeleteReportSubscription',
    SubscribeToAutomatedReports: 'SubscribeToAutomatedReports',
    UnsubscribeFromAutomatedReports: 'UnsubscribeFromAutomatedReports',
    UpdateAutomatedReportPreferences: 'UpdateAutomatedReportPreferences',
    TriggerReportSubscription: 'TriggerReportSubscription'
  },
  Fragment: {
    ReportSubscriptionFragment: 'ReportSubscriptionFragment',
    ReportSubscriptionResponseFragment: 'ReportSubscriptionResponseFragment'
  }
}